import { apiClient } from './api';

export interface FeedMessageMetadata {
  symbol?: string;
  bias?: string;
  strike?: number;
  contract_type?: string;
  expiry?: string;
  time_to_expiry_days?: number | null;
  bet_display?: string;
  reference_price?: number;
  multiplier?: number;
  alert_type?: string;
  condition?: string;
  top_bet?: boolean;
  events?: string;
}

export interface FeedMessage {
  id: number;
  content: string;
  bot_identity: string;
  display_name: string;
  author_username: string | null;
  source_type: 'composer' | 'wiseguy_alert';
  metadata: FeedMessageMetadata;
  attachments: { filename: string; url: string; content_type: string }[];
  created_at: string;
  updated_at: string;
}

interface PaginatedFeedResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: FeedMessage[];
}

export type { PaginatedFeedResponse };

export const wsjFeedService = {
  async getMessages(page = 1, pageSize = 20): Promise<PaginatedFeedResponse> {
    return apiClient.get<PaginatedFeedResponse>(
      `/api/jdash/wsj-feed/?page=${page}&page_size=${pageSize}`
    );
  },
};
